import parse from "date-fns/parse";

export default function getDateWithTimezone(timeZone: string): Date {
    const date = new Date().toLocaleString("en-GB", {timeZone})

    return parse(date, 'dd/MM/yyyy, HH:mm:ss', new Date())
}